/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualOtherOpexDto } from '../../models/backend-actual-other-opex-dto';
import { BackendPatchedActualOtherOpexRequestDto } from '../../models/backend-patched-actual-other-opex-request-dto';

export interface MonitoringActualsOtherOpexesPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedActualOtherOpexRequestDto;
}

export function monitoringActualsOtherOpexesPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsOtherOpexesPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsOtherOpexesPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualOtherOpexDto>;
    }),
  );
}

monitoringActualsOtherOpexesPartialUpdate$FormData.PATH = '/api/monitoring/actuals/other-opexes/{id}/';
